import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes";

export const logUser = (user, navigate) => {
  return {
    type: LOGIN_USER,
    payload: { user, navigate },
  };
};

export const loginSuccess = (data, navigate) => {
  return {
    type: LOGIN_SUCCESS,
    payload: { data, navigate },
  };
};

export const logoutUser = (history) => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
